import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { languageQuery, isMobileQuery, RoutablePage, formatCurrency, interpolate, getFeatureEnabled, getFeatureValueV2, MagicConfigMixin } from '@gig/magic-common';
import { Component, Mixins } from 'vue-property-decorator';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';
import { Feature, BALANCE_UPDATED, BALANCE_QUERY, USER_PROFILE_DATA, LANGUAGE_UPDATED, BREAKPOINT_DEVICE_UPDATED, IS_REDEEM_FLOW_UPDATED, LOCKED_AMOUNT_UPDATED, US_DOLLARS_BALANCE_UPDATED, BALANCE_FIAT_CURRENCY_QUERY } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
import { calculateRedeemableSweepFiat, getSweepRatio, isSweepcoinsAndFiatRatioEnabled } from '../../utils/helpers.js';
import { notificationService, NotificationStyle } from '@gig/magic-messaging';
import { AmlStatus } from '@gig/magic-sdk/dist/adapter/users/getAmlStatus';
import { validationMixin } from 'vuelidate';
import { required, minValue, maxValue } from 'vuelidate/lib/validators';

var SweepstakesRedeem = /** @class */ (function (_super) {
    __extends(SweepstakesRedeem, _super);
    function SweepstakesRedeem() {
        var _this = _super.call(this) || this;
        _this.isWithdrawAllowed = true;
        _this.isWithdrawAllowedByFeatureFlag = true;
        _this.redemptionLimit = 600;
        _this.amount = '';
        _this.redeemablePoints = 0;
        _this.promos = [];
        _this.activePromoId = '';
        _this.showSSN = false;
        _this.loading = false;
        _this.showLoading = true;
        _this.showVerificationProgress = false;
        _this.showWallet = false;
        _this.withdrawData = null;
        _this.fiatBalance = null;
        _this.numericRatio = 0;
        _this.isSweepcoinsAndFiatRatioEnabled = false;
        _this.redeemableSweepFiat = null;
        _this.fiatCurrency = '';
        _this.fetchCurrency();
        return _this;
    }
    SweepstakesRedeem.prototype.created = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var user, _b, _c, _d, fiatBalance, error_1;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        window.eventBus.publish(IS_REDEEM_FLOW_UPDATED, true);
                        return [4 /*yield*/, window.queryBus.query(USER_PROFILE_DATA)];
                    case 1:
                        user = _e.sent();
                        this.isWithdrawAllowed = (_a = user === null || user === void 0 ? void 0 : user.compliance.isWithdrawAllowed) !== null && _a !== void 0 ? _a : true;
                        _b = this;
                        return [4 /*yield*/, this.getIsWithdrawAllowedByFeatureFlag()];
                    case 2:
                        _b.isWithdrawAllowedByFeatureFlag =
                            _e.sent();
                        this.userProfileSubscription = magic.events.userProfileUpdated(function () { return __awaiter(_this, void 0, void 0, function () {
                            var updatedUser, _a;
                            var _this = this;
                            var _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0: return [4 /*yield*/, window.queryBus.query(USER_PROFILE_DATA)];
                                    case 1:
                                        updatedUser = _c.sent();
                                        this.showVerificationProgress = false;
                                        this.isWithdrawAllowed =
                                            (_b = updatedUser === null || updatedUser === void 0 ? void 0 : updatedUser.compliance.isWithdrawAllowed) !== null && _b !== void 0 ? _b : true;
                                        _a = this;
                                        return [4 /*yield*/, this.getIsWithdrawAllowedByFeatureFlag()];
                                    case 2:
                                        _a.isWithdrawAllowedByFeatureFlag =
                                            _c.sent();
                                        this.$nextTick(function () { return _this.$forceUpdate(); });
                                        return [2 /*return*/];
                                }
                            });
                        }); }).unsub;
                        this.promosSubscription = window.eventBus.subscribe([LANGUAGE_UPDATED, BREAKPOINT_DEVICE_UPDATED], function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, language, mobile, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0: return [4 /*yield*/, Promise.all([
                                            languageQuery(),
                                            isMobileQuery(),
                                        ])];
                                    case 1:
                                        _a = _c.sent(), language = _a[0], mobile = _a[1];
                                        _b = this;
                                        return [4 /*yield*/, this.fetchPromotions(language, mobile)];
                                    case 2:
                                        _b.promos = _c.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, { replay: true, distinct: true });
                        _c = this;
                        return [4 /*yield*/, isSweepcoinsAndFiatRatioEnabled()];
                    case 3:
                        _c.isSweepcoinsAndFiatRatioEnabled =
                            _e.sent();
                        _d = this;
                        return [4 /*yield*/, getSweepRatio()];
                    case 4:
                        _d.numericRatio = _e.sent();
                        this.balanceSubscription = window.eventBus.subscribe(BALANCE_UPDATED, function () { return __awaiter(_this, void 0, void 0, function () {
                            var balance, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, window.queryBus.query(BALANCE_QUERY, Currency.SWP)];
                                    case 1:
                                        balance = _b.sent();
                                        this.redeemablePoints = balance === null || balance === void 0 ? void 0 : balance.withdrawable;
                                        _a = this;
                                        return [4 /*yield*/, calculateRedeemableSweepFiat(this.redeemablePoints, this.isSweepcoinsAndFiatRatioEnabled)];
                                    case 2:
                                        _a.redeemableSweepFiat = _b.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, { replay: true });
                        return [4 /*yield*/, this.getFiatBalance()];
                    case 5:
                        fiatBalance = _e.sent();
                        if (!(fiatBalance && fiatBalance.withdrawable > 0)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.handleAbandonedFlow()];
                    case 6:
                        _e.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        this.showLoading = false;
                        _e.label = 8;
                    case 8:
                        _e.trys.push([8, 10, , 11]);
                        return [4 /*yield*/, this.triggerKYCVerifications(Feature.TRIGGER_KYC_VERIFICATIONS_BEFORE_ENTERING_REDEMPTION_SHOP)];
                    case 9:
                        _e.sent();
                        return [3 /*break*/, 11];
                    case 10:
                        error_1 = _e.sent();
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesRedeem.prototype.destroyed = function () {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var isMidRedeem, isFailedRedeem, error_2;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        (_a = this.promosSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
                        (_b = this.balanceSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
                        (_c = this.usDollarsBalanceSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
                        if (this.userProfileSubscription) {
                            this.userProfileSubscription();
                        }
                        window.eventBus.publish(IS_REDEEM_FLOW_UPDATED, false);
                        window.eventBus.publish(US_DOLLARS_BALANCE_UPDATED, true);
                        isMidRedeem = !this.withdrawData;
                        isFailedRedeem = ((_d = this.withdrawData) === null || _d === void 0 ? void 0 : _d.success) === false;
                        if (!((isMidRedeem || isFailedRedeem) &&
                            this.fiatBalance &&
                            this.fiatBalance.balance)) return [3 /*break*/, 4];
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, magic.methods.users.cancelRedeemSweepcoins()];
                    case 2:
                        _e.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _e.sent();
                        window.eventBus.publish(LOCKED_AMOUNT_UPDATED, true);
                        console.log('Failed to cancel redemption flow', error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesRedeem.prototype.onVerification = function () {
        this.routeTo({ route: RoutablePage.VERIFICATION });
    };
    SweepstakesRedeem.prototype.fetchCurrency = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(BALANCE_FIAT_CURRENCY_QUERY)];
                    case 1:
                        _a.fiatCurrency = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _b.sent();
                        console.error('Error fetching fiat currency:', error_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesRedeem.prototype.getFormattedPromoPrice = function (promo) {
        if (!this.isSweepcoinsAndFiatRatioEnabled) {
            return '';
        }
        return formatCurrency(promo.price / this.numericRatio, this.fiatCurrency, 2, 'narrowSymbol');
    };
    Object.defineProperty(SweepstakesRedeem.prototype, "redeemablePointsFormatted", {
        get: function () {
            return interpolate(this.$t('sweepstakes.redeemable-points'), {
                redeemablePoints: this.redeemablePoints,
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesRedeem.prototype, "dynamicButtonText", {
        get: function () {
            if (this.amount && this.isSweepcoinsAndFiatRatioEnabled) {
                var redeemableAmount = formatCurrency(+this.amount / this.numericRatio, this.fiatCurrency, 2, 'narrowSymbol');
                return interpolate(this.$t('sweepstakes-redeem.button-with-amount'), {
                    redeemableAmount: redeemableAmount,
                });
            }
            return this.$t('sweepstakes-redeem.button');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesRedeem.prototype, "minAmount", {
        get: function () {
            return this.promos.length
                ? Math.min.apply(Math, this.promos.map(function (promo) { return promo.price; })) : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesRedeem.prototype, "redeemDisabled", {
        get: function () {
            return this.redeemablePoints < this.minAmount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesRedeem.prototype, "errorMessage", {
        get: function () {
            return interpolate(this.$t('sweepstakes-redeem.input-error'), {
                min: this.minAmount.toLocaleString(),
                max: this.redeemablePoints.toLocaleString(),
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesRedeem.prototype, "getAmountFormatted", {
        get: function () {
            return interpolate(this.$t('sweepstakes.sweepcoins-long'), {
                amount: (+this.amount).toLocaleString(),
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesRedeem.prototype, "successWithdrawMessage", {
        get: function () {
            var _a;
            return interpolate(this.$t('sweepstakes-redeem.success-withdraw'), {
                redeemedSweepCoins: (+this.amount).toLocaleString(),
                transactionID: (_a = this.withdrawData) === null || _a === void 0 ? void 0 : _a.transactionID,
            });
        },
        enumerable: false,
        configurable: true
    });
    SweepstakesRedeem.prototype.getSweepCoinsFormatted = function (promo) {
        return interpolate(this.$t('sweepstakes.sweepcoins-short'), {
            amount: promo.price.toLocaleString(),
        });
    };
    SweepstakesRedeem.prototype.onPromoClick = function (promo) {
        this.activePromoId = promo.id;
        this.$v.amount.$model = promo.price;
    };
    SweepstakesRedeem.prototype.resetActivePromo = function () {
        this.activePromoId = '';
    };
    SweepstakesRedeem.prototype.onWithdrawResult = function (data) {
        this.withdrawData = data.detail[0];
    };
    SweepstakesRedeem.prototype.changeAmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.loading = true;
                        return [4 /*yield*/, magic.methods.users.cancelRedeemSweepcoins()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        error_4 = _a.sent();
                        window.eventBus.publish(LOCKED_AMOUNT_UPDATED, true);
                        return [3 /*break*/, 4];
                    case 3:
                        this.loading = false;
                        this.showSSN = false;
                        this.showWallet = false;
                        this.amount = '';
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesRedeem.prototype.onContinue = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_5, amountEstimation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.$v.amount.$invalid || this.redeemDisabled) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.triggerKYCVerifications(Feature.TRIGGER_KYC_VERIFICATIONS_BEFORE_SELECTING_SHOP_REDEMPTION_METHOD)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        // Error already handled in triggerKYCVerifications
                        console.error('Error in triggerKYCVerifications', error_5);
                        return [2 /*return*/];
                    case 4:
                        // Check if withdrawal is allowed after KYC verification
                        if (!this.isWithdrawAllowed) {
                            console.error('Withdrawal not allowed');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getFiatAmountEstimation()];
                    case 5:
                        amountEstimation = _a.sent();
                        return [4 /*yield*/, this.shouldTriggerSsnForAmount(amountEstimation)];
                    case 6:
                        if (!_a.sent()) return [3 /*break*/, 7];
                        this.showSSN = true;
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, this.gotToCashierRedemptionPage()];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesRedeem.prototype.getFiatAmountEstimation = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, +this.amount / this.numericRatio];
            });
        });
    };
    SweepstakesRedeem.prototype.getSweepcoinsEstimation = function (fiatAmount) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, fiatAmount * this.numericRatio];
            });
        });
    };
    SweepstakesRedeem.prototype.handleAbandonedFlow = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fiatBalance, sweepcoins;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 4, 5]);
                        return [4 /*yield*/, this.getFiatBalance()];
                    case 1:
                        fiatBalance = _a.sent();
                        return [4 /*yield*/, this.getSweepcoinsEstimation(fiatBalance.withdrawable)];
                    case 2:
                        sweepcoins = _a.sent();
                        this.amount = sweepcoins.toString();
                        this.fiatBalance = fiatBalance;
                        return [4 /*yield*/, this.shouldTriggerSsnForAmount(fiatBalance.withdrawable)];
                    case 3:
                        if (_a.sent()) {
                            this.showSSN = true;
                        }
                        else {
                            this.showWallet = true;
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        this.showLoading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesRedeem.prototype.shouldTriggerSsnForAmount = function (amount) {
        return __awaiter(this, void 0, void 0, function () {
            var profile, _a, totalRedemptionAmount;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getProfile()];
                    case 1:
                        profile = _b.sent();
                        if (profile.user.taxId) {
                            return [2 /*return*/, false];
                        }
                        this.loading = true;
                        return [4 /*yield*/, magic.methods.users.getTotalRedemptionAmount()];
                    case 2:
                        _a = (_b.sent()).totalRedemptionAmount, totalRedemptionAmount = _a === void 0 ? 0 : _a;
                        this.loading = false;
                        return [2 /*return*/, amount + totalRedemptionAmount > this.redemptionLimit];
                }
            });
        });
    };
    SweepstakesRedeem.prototype.gotToCashierRedemptionPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fiatBalance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 4, 5]);
                        this.loading = true;
                        return [4 /*yield*/, this.getFiatBalance()];
                    case 1:
                        fiatBalance = _a.sent();
                        if (!((fiatBalance === null || fiatBalance === void 0 ? void 0 : fiatBalance.withdrawable) === 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, Promise.all([
                                magic.methods.wallet.redeemSweepCoins(+this.amount),
                                this.waitForFiatBalanceUpdate(),
                            ])];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.showWallet = true;
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        if (!this.showWallet) {
                            notificationService.error(this.$t('sweepstakes-redeem.button-error'));
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesRedeem.prototype.waitForFiatBalanceUpdate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fiatCurrency;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(BALANCE_FIAT_CURRENCY_QUERY)];
                    case 1:
                        fiatCurrency = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve) {
                                var subscription = window.eventBus.subscribe(BALANCE_UPDATED, function (event) {
                                    var _a;
                                    if (((_a = event.payload) === null || _a === void 0 ? void 0 : _a.currency) !== fiatCurrency) {
                                        return;
                                    }
                                    _this.fiatBalance = event.payload;
                                    subscription.unsubscribe();
                                    resolve();
                                });
                            })];
                }
            });
        });
    };
    SweepstakesRedeem.prototype.getProfile = function () {
        return window.queryBus.query(USER_PROFILE_DATA);
    };
    SweepstakesRedeem.prototype.fetchPromotions = function (language, mobile) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, magic.methods.promotions.filter('sweepstakes redeem shop', language, mobile)];
                    case 1: return [2 /*return*/, (_a.sent()).map(function (promo) {
                            return {
                                id: promo.id,
                                price: _this.getShopInfo(promo).itemCost.amount,
                            };
                        })];
                }
            });
        });
    };
    SweepstakesRedeem.prototype.getShopInfo = function (promo) {
        // @ts-ignore
        return promo.sweepStakesRedeemShop;
    };
    SweepstakesRedeem.prototype.getFiatBalance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fiatCurrency;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(BALANCE_FIAT_CURRENCY_QUERY)];
                    case 1:
                        fiatCurrency = _a.sent();
                        return [2 /*return*/, window.queryBus.query(BALANCE_QUERY, fiatCurrency)];
                }
            });
        });
    };
    SweepstakesRedeem.prototype.getIsWithdrawAllowedByFeatureFlag = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, triggerKYCVerificationsBeforeSelectingShopRedemptionMethod;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(USER_PROFILE_DATA)];
                    case 1:
                        user = _a.sent();
                        return [4 /*yield*/, getFeatureEnabled(Feature.TRIGGER_KYC_VERIFICATIONS_BEFORE_SELECTING_SHOP_REDEMPTION_METHOD)];
                    case 2:
                        triggerKYCVerificationsBeforeSelectingShopRedemptionMethod = _a.sent();
                        if (triggerKYCVerificationsBeforeSelectingShopRedemptionMethod &&
                            (user === null || user === void 0 ? void 0 : user.compliance.idVerificationStatus) === AmlStatus.NOT_SET) {
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, this.isWithdrawAllowed];
                }
            });
        });
    };
    SweepstakesRedeem.prototype.triggerKYCAndWaitForProfileUpdate = function (intent) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        // Set up the event listener first
                        var unsubscribe = magic.events.userProfileUpdated(function () {
                            unsubscribe();
                            resolve();
                        }).unsub;
                        // Trigger the KYC verification request
                        magic.methods.users
                            .triggerKYCVerificationsRequest({ intent: intent })
                            .then(function (res) {
                            if (!res.sent) {
                                unsubscribe();
                                reject(new Error('KYC verification request not sent'));
                            }
                        })
                            .catch(function (error) {
                            unsubscribe();
                            reject(error);
                        });
                    })];
            });
        });
    };
    SweepstakesRedeem.prototype.triggerKYCVerifications = function (feature) {
        return __awaiter(this, void 0, void 0, function () {
            var user, triggerKYCVerifications, triggerKycVerificationsValue, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, window.queryBus.query(USER_PROFILE_DATA)];
                    case 1:
                        user = _a.sent();
                        return [4 /*yield*/, getFeatureEnabled(feature)];
                    case 2:
                        triggerKYCVerifications = _a.sent();
                        return [4 /*yield*/, getFeatureValueV2(feature)];
                    case 3:
                        triggerKycVerificationsValue = _a.sent();
                        if (!(triggerKYCVerifications &&
                            triggerKycVerificationsValue &&
                            (user === null || user === void 0 ? void 0 : user.compliance.idVerificationStatus) === AmlStatus.NOT_SET)) return [3 /*break*/, 5];
                        this.startKYCVerificationProgress();
                        // Wait for both the request AND the profile update event
                        return [4 /*yield*/, this.triggerKYCAndWaitForProfileUpdate(triggerKycVerificationsValue)];
                    case 4:
                        // Wait for both the request AND the profile update event
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        this.showVerificationProgress = false;
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_6 = _a.sent();
                        this.triggerKYCVerificationsError();
                        throw error_6; // Re-throw to prevent caller from continuing
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesRedeem.prototype.startKYCVerificationProgress = function () {
        this.isWithdrawAllowed = false;
        this.isWithdrawAllowedByFeatureFlag = false;
        this.showVerificationProgress = true;
    };
    SweepstakesRedeem.prototype.triggerKYCVerificationsError = function () {
        notificationService.show(this.$t('sweepstakes.verification-fails'), {
            style: NotificationStyle.ERROR,
            uniqueID: 'kyc-verifications-error',
        });
        this.routeTo({ route: RoutablePage.HOME });
        this.showVerificationProgress = false;
    };
    SweepstakesRedeem = __decorate([
        Component({
            name: 'sweepstakes-redeem',
            validations: function () {
                var rules = {};
                rules.amount = {
                    required: required,
                    minValue: minValue(this.minAmount),
                    maxValue: maxValue(this.redeemablePoints),
                };
                return rules;
            },
        }),
        __metadata("design:paramtypes", [])
    ], SweepstakesRedeem);
    return SweepstakesRedeem;
}(Mixins(validationMixin, MagicConfigMixin)));

export default SweepstakesRedeem;
